import { K as KEYBOARD_KEYNAMES } from '../keyboardKeynames-AmBipDtf.js';

function getTabbableElements(element) {
  if (!element || !(element instanceof HTMLElement)) return [];

  // https://github.com/focus-trap/tabbable
  const tabbables = ['button:not([disabled]):not([tabindex="-1"])', '[href]:not([disabled]):not([tabindex="-1"])', 'input:not([disabled]):not([tabindex="-1"]):not([type="hidden"])', 'select:not([disabled]):not([tabindex="-1"])', 'option:not([disabled]):not([tabindex="-1"])', 'textarea:not([disabled]):not([tabindex="-1"])', 'iframe:not([tabindex="-1"])', '[contenteditable]:not([contenteditable="false"]):not([tabindex="-1"])', '[tabindex]:not([tabindex="-1"])'];
  return Array.from(element.querySelectorAll(tabbables.join(',')));
}
function trapTabFocus(event, context, includeParent = false) {
  const {
    key,
    shiftKey
  } = event;
  if (context) {
    const focusableEls = getTabbableElements(context);
    const firstFocusableEl = !includeParent ? focusableEls[0] : context;
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    // trap focus for tab
    if (key === KEYBOARD_KEYNAMES.TAB && !shiftKey) {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        event.preventDefault();
      }
    }

    // trap focus for shift + tab
    if (key === KEYBOARD_KEYNAMES.TAB && shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        event.preventDefault();
      }
    }
  }
}

export { trapTabFocus as t };
//# sourceMappingURL=trapTabFocus-vpg0lK2r.js.map
